import { render, staticRenderFns } from "./AddEventNotes.vue?vue&type=template&id=6ae9a210&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventNotes.vue"
export default component.exports